import Api from "@/services/api";
import Vue from 'vue';

export default {
    namespaced: true,
    state: {
        currentAiSettings: {
            isConfigured: false
        },
        currentAiUsageReport: {
            items: [],
            totalInputTokens: 0,
            totalOutputTokens: 0,
            totalEstimatedCostUsd: 0
        }
    },
    mutations: {
        SET_CURRENT_AI_SETTINGS(state, currentAiSettings){
            state.currentAiSettings = currentAiSettings;
        },
        SET_CURRENT_AI_USAGE_REPORT(state, currentAiUsageReport){
            state.currentAiUsageReport = currentAiUsageReport;
        }
    },
    actions: {
        async getAiSettings({commit}, companyId){
            let token = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${token}` }
            };
            let response = await Api().get(`/Web/Ai/Settings/${companyId}`, config)
            .catch(err => {
                console.error(err.message);
            });
            commit('SET_CURRENT_AI_SETTINGS', response.data);
            return response.data;
        },
        async updateAiSettings({dispatch}, settings){
            let token = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${token}` }
            };
            let success = true;
            await Api().put(`/Web/Ai/Settings`, settings, config).catch(() => {
                success = false;
            });
            if(success){
                await dispatch('getAiSettings', settings.companyId);
            }
            return success;
        },
        async generateContent(context, {companyId, feature, prompt, contactId, optionCount, includeContactFields, includeMessageHistory, hubSpotCompanyIds, hubSpotDealIds, hubSpotTicketIds}){
            let token = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${token}` }
            };
            try {
                let response = await Api().post(`/Web/Ai/Generate`, {
                    companyId, feature, prompt, contactId, optionCount, includeContactFields, includeMessageHistory,
                    hubSpotCompanyIds, hubSpotDealIds, hubSpotTicketIds
                }, config);
                return {
                    success: true,
                    text: response.data.text,
                    options: response.data.options,
                    systemPrompt: response.data.systemPrompt,
                    sentPrompt: response.data.prompt
                };
            } catch (err) {
                let message = err.response && err.response.data && err.response.data.message
                    ? err.response.data.message
                    : 'AI generation failed.';
                let data = err.response && err.response.data ? err.response.data : {};
                return { success: false, message, systemPrompt: data.systemPrompt, sentPrompt: data.prompt };
            }
        },
        async getHubSpotAssociatedObjects(context, {companyId, contactId, type}){
            let token = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${token}` }
            };
            try {
                let response = await Api().get(`/Web/Ai/HubSpotAssociations/${companyId}/${contactId}/${type}`, config);
                return response.data || [];
            } catch (err) {
                console.error(err.message);
                return [];
            }
        },
        async getAiUsageReport({commit}, {companyId, from, to}){
            let token = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${token}` },
                params: { from, to }
            };
            let response = await Api().get(`/Web/Ai/Usage/${companyId}`, config)
            .catch(err => {
                console.error(err.message);
            });
            commit('SET_CURRENT_AI_USAGE_REPORT', response.data);
            return response.data;
        }
    }
}
